/**
 * customer reviews section js here
 */

jQuery(function() { 
    $(document).on("click", "a.customer-reviews__arrow-next", function(e) {
        e.preventDefault();
        var pos = $(this).closest('.customer-reviews-group-parent').find(".customer-reviews-group").scrollLeft() + 320;
        $(this).closest('.customer-reviews-group-parent').find(".customer-reviews-group").scrollLeft(pos);
    });    
    $(document).on("click", "a.customer-reviews__arrow-prev", function(e) {
        e.preventDefault();
        var pos = $(this).closest('.customer-reviews-group-parent').find(".customer-reviews-group").scrollLeft() - 320;
        $(this).closest('.customer-reviews-group-parent').find(".customer-reviews-group").scrollLeft(pos);
    });
});